// Registers the service worker emitted by workbox-webpack-plugin.
//
// Safe to call on any platform: React Native's navigator has no serviceWorker,
// so this is a no-op there. Registration is skipped in development because the
// webpack dev server serves no service-worker.js and a stale one would shadow
// live reloads.

export const registerServiceWorker = (): void => {
	if (typeof window === "undefined") return;
	if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
	if (__DEV__) return;

	const register = () => {
		navigator.serviceWorker
			.register("/service-worker.js")
			.catch(error => console.warn("[pwa] service worker registration failed", error));
	};

	// React flushes this effect after paint, which on a small page happens after
	// the window "load" event has already fired — a listener added at that point
	// would never run. Register immediately when the document is already done.
	if (document.readyState === "complete") {
		register();
	} else {
		window.addEventListener("load", register);
	}
};

export default registerServiceWorker;
